// extracted by mini-css-extract-plugin
export default {"auth_Title":"AuthHeader_auth_Title__AAf8o","auth_Others":"AuthHeader_auth_Others__waLuP"};